import logo from './logo.svg';
import './App.css';
import { HJome } from './components/HJome';

function App() {
  return (
   <HJome/>

    
  );
}

export default App;
